'use client';

import { BROptimisedImage, type OptimisedImageProps } from '@bedrock/core/react/components/client';
import { useIsUpTo } from 'hooks';

export default function FooterImage(props: Readonly<OptimisedImageProps>) {
  const isUpToDesktop = useIsUpTo('2xl');

  return (
    <BROptimisedImage
      className="-z-1 left absolute top-[-85px] 2xl:top-[-158px]"
      height={isUpToDesktop ? 170 : 316}
      width={isUpToDesktop ? 383 : 712}
      {...props}
    />
  );
}
